// Arcane Sanctum theme — kept intentionally minimal.
// All core functionality (add to cart, checkout) uses native HTML forms
// that work without JavaScript, so nothing here is required for the
// site to function. The one exception: the cart quantity control below.
//
// The quantity input can be typed into directly, or adjusted with the
// +/- buttons. Either way, the change isn't submitted immediately —
// it's debounced, so rapid clicks or typing only send ONE request after
// you pause for a moment, rather than one full page reload per click.
// This avoids hammering Shopify's cart endpoint with many rapid
// submissions in a row, which can otherwise get silently blocked.

(function () {
  var DEBOUNCE_MS = 600;
  var timers = {};

  function clamp(input) {
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
    var form = input.closest('form');
    var message = form ? form.querySelector('.cart__qty-message') : null;
    if (max !== null && value > max) {
      value = max;
      if (message) message.textContent = 'Only ' + max + ' available';
    } else if (message) {
      message.textContent = '';
    }
    input.value = value;
    return value;
  }

  function scheduleSubmit(form) {
    var line = form.getAttribute('data-line');
    if (timers[line]) clearTimeout(timers[line]);
    timers[line] = setTimeout(function () {
      form.submit();
    }, DEBOUNCE_MS);
  }

  // Stepper buttons: adjust value locally, then debounce-submit.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-stepper__btn');
    if (!btn || btn.disabled) return;

    var form = btn.closest('form');
    var input = form.querySelector('.qty-stepper__input');
    var current = parseInt(input.value, 10) || 0;

    if (btn.classList.contains('qty-stepper__btn--plus')) {
      input.value = current + 1;
    } else if (btn.classList.contains('qty-stepper__btn--minus')) {
      input.value = Math.max(0, current - 1);
    }

    clamp(input);
    scheduleSubmit(form);
  });

  // Typing directly into the field: clamp and debounce-submit on input.
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.qty-stepper__input');
    if (!input) return;
    var form = input.closest('form');
    scheduleSubmit(form);
  });

  // Pressing Enter submits immediately, no wait.
  document.addEventListener('keydown', function (e) {
    var input = e.target.closest('.qty-stepper__input');
    if (!input || e.key !== 'Enter') return;
    e.preventDefault();
    var form = input.closest('form');
    var line = form.getAttribute('data-line');
    if (timers[line]) clearTimeout(timers[line]);
    clamp(input);
    form.submit();
  });

  // Leaving the field also submits immediately, no wait.
  document.addEventListener('blur', function (e) {
    var input = e.target.closest && e.target.closest('.qty-stepper__input');
    if (!input) return;
    var form = input.closest('form');
    var line = form.getAttribute('data-line');
    if (timers[line]) clearTimeout(timers[line]);
    clamp(input);
    form.submit();
  }, true);
})();
